import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../../style/colors';
import { ITheme } from '../../../../style/theme';

interface StyleProps {
  active?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  menuList: {
    marginTop: theme.spacing(3),
  },
  logo: {
    width: 84,
    height: 24,
  },
  menuItem: {
    position: 'relative',
    marginBottom: theme.spacing(5),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(1.5),
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: colors.powderBlue,
        borderRadius: 8,
      },
    },
  },
  menuIcon: {
    padding: 6,
  },
  logoutIcon: {
    padding: theme.spacing(1),
    backgroundColor: colors.gainsboro,
  },
  menuLink: {
    textAlign: 'center',
    display: 'block',
    fontSize: 16,
    lineHeight: '24px',
    [theme.breakpoints.up('sm')]: {
      fontSize: 14,
      lineHeight: '22px',
    },
    fontWeight: 'bold',
    textDecoration: 'none',
    color: colors.darkestGray,
    '&:not($menuLinkActive):hover': {
      '&$logoutIcon': {
        backgroundColor: colors.darkestGray,
      },
    },
  },
  menuLinkActive: {
    '& path': {
      fill: colors.darkestBlue,
    },
  },
  indicator: {
    position: 'absolute',
    top: 0,
    left: -16,
    width: 4,
    height: '100%',
    borderStyle: 'solid',
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    borderColor: colors.darkestBlue,
    backgroundColor: colors.darkestBlue,
  },
  menuLabel: {
    fontWeight: ({ active }) => (active ? 'bold' : 'normal'),
    color: colors.darkestBlue,
  },
  menuButton: {
    justifyContent: 'center',
  },
  divider: {
    padding: '0 8px',
  },
  languageContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
}));
